var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _path, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGovernment = function SvgGovernment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 31,
    x: 11,
    y: 24.764,
    fill: "#FF9D43",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    x: 9,
    y: 53.764,
    fill: "#FFD2A8",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    x: 9,
    y: 26,
    fill: "#FFD2A8",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 31,
    x: 30,
    y: 24.764,
    fill: "#FF9D43",
    rx: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    x: 28,
    y: 53.764,
    fill: "#FFD2A8",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    x: 28,
    y: 26,
    fill: "#FFD2A8",
    rx: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 31,
    x: 49,
    y: 24.764,
    fill: "#FF9D43",
    rx: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    x: 47,
    y: 53.764,
    fill: "#FFD2A8",
    rx: 2
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 5,
    x: 47,
    y: 26,
    fill: "#FFD2A8",
    rx: 2
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 4,
    x: 6,
    y: 56.764,
    fill: "#6C9BF1",
    rx: 2
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 6,
    x: 3,
    y: 58.764,
    fill: "#2F68D1",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M35.894 6.211a2 2 0 0 0-1.788 0l-25 12.5A2 2 0 0 0 8 20.5v4.264a2 2 0 0 0 2 2h50a2 2 0 0 0 2-2V20.5a2 2 0 0 0-1.106-1.789zM35 19.764a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
    clipRule: "evenodd"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 4,
    x: 6,
    y: 23.764,
    fill: "#6C9BF1",
    rx: 2
  })));
};
export default SvgGovernment;